
// State Object for ContractsRoyalty. Dont directly mutate it anywhere except the contracts/mutations.js file
export const contractsRoyaltyState = {
  contractsRoyaltyData: null,
  contractsList: null,
  contractsDetails: null,
  display_contract_deductions_subtab:null,
  display_auto_balance_subtab:null,
}


